import { SproToasterService } from "../../sproLib/spro/services/spro-toaster/spro-toaster.service";
import { Component } from "@angular/core";
import {
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { Md5 } from "ts-md5/dist/md5";

@Component({
  selector: "app-register_mdp",
  styleUrls: ["./register.component.scss"],
  templateUrl: "./register_mdp.component.html"
})
export class cls_register_mdp {
  /* ###########################################  VARIABLES  #######################################################*/

  /** Nom de la page afin de gérer la traduction */
  public w_titre_trad = "registerPage_mdp.";

  /**
   * Formulaire des données
   * 7 caractères, une lettre, un chiffre et un caractère spécial
   */
  public form_profil: FormGroup = new FormGroup({
    username: new FormControl("", [
      Validators.required,
      Validators.maxLength(20)
    ]),
    motdepasse: new FormControl("", [
      Validators.required,
      Validators.minLength(7),
      Validators.maxLength(45),
      Validators.pattern("^(?=.*[0-9])(?=.*[a-z])(?=.*[@#$*_%^&+=.,;:/£<>]).*$")
    ]),
    motdepasse2: new FormControl("", [
      Validators.required,
      Validators.minLength(7),
      Validators.maxLength(45),
      Validators.pattern("^(?=.*[0-9])(?=.*[a-z])(?=.*[@#$*_%^&+=.,;:/£<>]).*$")
    ])
  });

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(
    public s_toaster: SproToasterService
  ) {}

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * Test du formulaire et retourne les valeurs
   */
  public proc_getData(): any {
    //Verifications de la validité du mot de passe
    if (this.form_profil.controls.motdepasse.valid === false) {
      this.s_toaster.proc_toastTradError(this.w_titre_trad + "msg_MDPInvalid");
      return null;
    }

    //Verifications de la validité des Validators (format /required)
    if (this.form_profil.status === "INVALID") {
      this.s_toaster.proc_toastTradError("pageProfil.msg_FormInval");
      return null;
    }

    //Verifications de la confirmation MDP
    if (
      this.form_profil.controls.motdepasse.value !==
      this.form_profil.controls.motdepasse2.value
    ) {
      this.s_toaster.proc_toastTradError(this.w_titre_trad + "msg_MDPDiff");
      return null;
    }

    const h_data = {
      username: this.form_profil.controls["username"].value,
      motdepasse: Md5.hashStr(this.form_profil.controls["motdepasse"].value)
    };

    return h_data;
  }

  /**
   * Retourne le user
   */
  public proc_getUser(): string {
    return this.form_profil.controls["username"].value;
  }

  /**
   * Retourne le MDP
   */
  public proc_getMDP(): string {
    return this.form_profil.controls["motdepasse"].value;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/pages/register/register_mdp.component.ts